import axios from '../../utils/axiosConfig';
import { Contexture } from './Contexture';

const BASE_URL = `${process.env.REACT_APP_LAMBDA_API_URL}/integrations/jira`;

export class Jira {
  static async getHealth() {
    const response = await axios.get(`${BASE_URL}/health`, {
      headers: Contexture.getHeaders(),
    });
    return response.data;
  }

  static async getConfig() {
    const response = await axios.get(`${BASE_URL}/config`, {
      headers: Contexture.getHeaders(),
    });
    return response.data;
  }

  static async setup(data) {
    const response = await axios.post(`${BASE_URL}/setup`, data, {
      headers: {
        ...Contexture.getHeaders(),
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  }

  static async updateConfig(data) {
    const response = await axios.patch(`${BASE_URL}/config`, data, {
      headers: {
        ...Contexture.getHeaders(),
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  }

  static async disconnect() {
    const response = await axios.delete(`${BASE_URL}/disconnect`, {
      headers: Contexture.getHeaders(),
    });
    return response.data;
  }
}
